import axios from 'axios';
import VueCookies from 'vue-cookies';

const logInApi = {
  // getLogin
  getLogin: async ({ email, password, deviceToken, deviceOs, chatId }) => {
    return await axios.post('/api/auth/v2/login', { email, password, deviceToken, deviceOs, chatId });
  },
  // mailAcceptCheck
  mailAcceptCheck: async ({ email, comeFrom }) => {
    return await axios.post(
      '/api/user/mailAcceptCheck',
      { email, comeFrom },
      { headers: { 'X-AUTH-TOKEN': VueCookies.get('aToken') } }
    );
  },
  // getLoginUser
  getLoginUser: async ({ email }) => {
    return await axios.post(
      '/api/user/getLoginUser',
      { email },
      { headers: { 'X-AUTH-TOKEN': VueCookies.get('aToken') } }
    );
  },
  // getMySpaceInfoCheck
  getMySpaceInfoCheck: async ({ spaceId, userId }) => {
    return await axios.post(
      '/api/profile/getMySpaceInfoCheck',
      { spaceId, userId },
      { headers: { 'X-AUTH-TOKEN': VueCookies.get('aToken') } }
    );
  },
  // getMySpaceInfo
  getMySpaceInfo: async ({ spaceId }) => {
    return await axios.post(
      '/api/profile/getMySpaceInfo',
      { spaceId },
      { headers: { 'X-AUTH-TOKEN': VueCookies.get('aToken') } }
    );
  },
  // checkSpace
  checkSpace: async ({ userId }) => {
    return await axios.post(
      '/api/profile/checkSpace',
      { userId },
      { headers: { 'X-AUTH-TOKEN': VueCookies.get('aToken') } }
    );
  },
  // subscribeSpaceList
  subscribeSpaceList: async ({ userId }) => {
    return await axios.post(
      '/api/profile/subscribeSpaceList',
      { userId },
      { headers: { 'X-AUTH-TOKEN': VueCookies.get('aToken') } }
    );
  }
};

export default logInApi;
